/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect } from 'react';
import { Spin } from 'antd';

import { SortEnd } from 'react-sortable-hoc';
import '@react-awesome-query-builder/antd/css/compact_styles.css';
import 'antd/dist/antd.css';

import PrimaryButton from '../../../lib/primary-button';

import RulesContainer from '../rules/rules.container';

import { Input, Rule } from '../../../../store/modules/rules';
import { useActions } from '../../../providers/actions-provider/actions.context';

type IFinalRulesProps = {
  target: string;
  rules: Rule[];
  loading: boolean;
};

const RulesWrapper = ({ target, rules, loading }: IFinalRulesProps): JSX.Element => {
  const { ruleActions } = useActions();

  useEffect(() => {
    ruleActions.getRulesAndStatements(target);
  }, []);

  // eslint-disable-next-line
  const onValueChange = (value: any, rule: Rule, input: Input | null) => {
    ruleActions.setRuleValue(value, rule, input, target);
  };

  const onSaveChangesClick = () => {
    ruleActions.saveRules(target);
  };

  const onStatementTypeChange = (type:string, rule: Rule) => {
    ruleActions.resetStatementRule(type, rule, target);
  };

  const onSortEnd = (sort: SortEnd) => {
    ruleActions.moveRule(sort.oldIndex, sort.newIndex, target, null);
  };

  return (
    <div style={{ width: '100%' }}>
      {loading ? (
        <div style={{ width: '100%', textAlign: 'center' }}><Spin /></div>
      ) : (
        <>
          <RulesContainer
            onSortEnd={onSortEnd}
            useDragHandle
            rules={rules}
            level={0}
            onChange={onValueChange}
            onStatementTypeChange={onStatementTypeChange}
            target={target}
          />
          <br />
          <PrimaryButton
            type="submit"
            className="fields-table__button-next"
            style={{ width: 280 }}
            onClick={onSaveChangesClick}
            loading={loading}
          >
            Save changes
          </PrimaryButton>
        </>
      )}
    </div>
  );
};
export default RulesWrapper;
